import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import type { FC } from "react";

import * as Styled from "./GetUpdatesPill.styles";

interface IGetUpdatesPillProps {
  raised: boolean;
  onClick: () => void;
}

export const GetUpdatesPill: FC<IGetUpdatesPillProps> = ({
  raised,
  onClick,
}) => {
  return (
    <Styled.Pill
      $raised={raised}
      variant="contained"
      startIcon={<WorkspacePremiumOutlinedIcon />}
      onClick={onClick}
    >
      Claim free plan
    </Styled.Pill>
  );
};
